import React, {useRef} from "react";
import Select, {components} from "react-select";

const InputSelect = ({
                         name,
                         label,
                         options,
                         value,
                         onChange,
                         required = false,
                         error = "",
                         firstOption = "",
                         size = "sm",
                         disabled = false,
                     }) => {
    const selectRef = useRef(null);

    const customStyles = {
        control: (base) => ({
            ...base,
            minHeight: size === "sm" ? "2rem" : "2.5rem",
            borderRadius: "0.5rem",
            border: error ? "1px solid #EF4444" : "1px solid #D1D5DB",
            boxShadow: "none",
            backgroundColor: disabled ? "#E5E7EB" : "white",
            "&:hover": {
                border: error ? "1px solid #EF4444" : "1px solid #D1D5DB",
            },
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
            maxHeight: "300px",
            overflowY: "auto",
        }),
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (base) => ({
            ...base,
            padding: size === "sm" ? "0.5rem" : "0.75rem",
        }),
        input: (base) => ({
            ...base,
            padding: size === "sm" ? "0.35rem" : "0.5rem",
        }),
    };

    const finalOptions = firstOption
        ? [{label: firstOption, value: ""}, ...options]
        : options;

    const selectedOption = finalOptions.find((opt) => opt.value === value) || null;

    const handleClear = () => {
        if (onChange) onChange("");
        if (selectRef.current) selectRef.current.blur();
    };

    return (
        <div className="w-full my-4">
            <div className="w-full relative">
                <label
                    className="absolute -top-2.5 px-1 bg-white right-3 z-10 block text-sm font-semibold rounded-lg"
                    htmlFor={name}
                >
                    {label} {required && <span className="text-red-500 font-light">*</span>}
                </label>

                <div className="relative">
                    <Select
                        ref={selectRef}
                        inputId={name}
                        name={name}
                        options={finalOptions}
                        value={selectedOption}
                        onChange={(selected) => onChange(selected?.value || "")}
                        placeholder="انتخاب کنید..."
                        isClearable={false} // چون خودمون دکمه جدا گذاشتیم
                        styles={customStyles}
                        menuPortalTarget={typeof window !== "undefined" ? document.body : null}
                        menuPosition="fixed"
                        className={`react-select-container text-center ${size === "sm" ? "text-sm" : "text-lg"}`}
                        classNamePrefix="react-select"
                        components={{
                            LoadingIndicator: () => (
                                <svg
                                    className="animate-spin h-5 w-5 text-gray-500 mr-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                    />
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    />
                                </svg>
                            ),
                        }}
                    />
                    {selectedOption && (
                        <button
                            type="button"
                            onClick={handleClear}
                            className="absolute left-11 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                            aria-label="Clear input"
                        >
                            <svg
                                className="h-4 w-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    )}
                </div>

                {error && <p className="text-red-500 text-xs mt-2">{error}</p>}
            </div>
        </div>
    );
};

export default InputSelect;
